<template>
  <v-card style="position:relative">
    <v-tabs
      v-model="tab"
      background-color="primary accent-4"
      center-active
      dark
    >
      <v-tab href="#tab-1">
        我的客户
      </v-tab>

      <v-tab href="#tab-2">
        个人资料
      </v-tab>
    </v-tabs>
    <v-container
      v-if="tab==='tab-1'"
      fluid
      style="position:absolute;left:0px;top:48px;width:100%; z-index:5;padding:0px"
    >
      <v-data-iterator
        :items="items"
        hide-default-footer
      >
        <template v-slot:header>
          <v-toolbar
            dark
            color="cyan darken-1"
            size="20"
            height="50px"
          >
            <v-text-field
              v-model="keyword"
              clearable
              solo-inverted
              hide-details
              prepend-inner-icon="mdi-magnify"
              label="关键词"
              style="width:150px"
              dense
              @change="selectsw"
            />
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              style="z-index:60;"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dates"
                  clearable
                  solo-inverted
                  hide-details
                  label="时间范围"
                  dense
                  style="margin-left:10px;width:210px;"
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  @change="selectsw"
                  @blur="selectsw"
                />
              </template>
              <v-date-picker
                v-model="dates"
                range
                no-title
                locale="zh-cn"
              />
            </v-menu>
            <template v-if="$vuetify.breakpoint.mdAndUp">
              <v-select
                v-if="userInfo.roles==='root' || userInfo.roles==='sem'"
                v-model="uid"
                clearable
                solo-inverted
                hide-details
                :items="keys"
                :menu-props="{ top: true, offsetY: true }"
                prepend-inner-icon="mdi-account"
                item-text="name"
                item-value="id"
                label="商务"
                style="margin-left:10px;width:10%;"
                dense
                @change="selectsw"
              />
              <v-select
                v-model="status"
                clearable
                solo-inverted
                hide-details
                :items="items"
                :menu-props="{ top: true, offsetY: true }"
                prepend-inner-icon="mdi-autorenew"
                item-text="label"
                item-value="value"
                label="状态"
                style="margin-left:10px;width:10%;"
                dense
                @change="selectsw"
              />
              <v-spacer />
              <v-btn
                depressed
                color="green accent-4"
                :value="false"
                title="添加客户"
                style="height: 36px;margin-right:5px;"
                @click="add"
              >
                <v-icon>mdi mdi-account-multiple-plus</v-icon>
              </v-btn>
              <v-btn-toggle
                v-model="sortDesc"
                mandatory
              >
                <v-btn
                  depressed
                  color="cyan accent-4"
                  :value="false"
                  title="看板模式"
                  style="height: 36px;"
                >
                  <v-icon>mdi-animation</v-icon>
                </v-btn>
                <v-btn
                  depressed
                  color="cyan accent-4"
                  :value="true"
                  title="表格模式"
                  style="height: 36px;"
                >
                  <v-icon>mdi-apps</v-icon>
                </v-btn>
              </v-btn-toggle>
            </template>
          </v-toolbar>
        </template>
      </v-data-iterator>
    </v-container>

    <v-tabs-items
      v-model="tab"
      style="width:100%;overflow-x:scroll;"
    >
      <!--tab1-content-->
      <v-tab-item
        key="1"
        value="tab-1"
        style="width:100%;background:#f7f7f7;"
      >
        <v-list
          v-if="sortDesc===false"
          style="width:2500px;height:76vh;overflow:hidden;margin:40px 0px 0px 0px"
        >
          <v-list-item
            style="width:300px;max-width:300px;float:left;"
          >
            <v-list-item-content
              class="mx-auto"
              style="width:300px;"
            >
              <!--
              <v-toolbar
                color="info"
                dark
                style="height: 34px;line-height: 34px;"
              >
                <v-icon
                  small
                  class="mr-2"
                >
                  mdi mdi-account-convert
                </v-icon>
                <v-div style="height: 34px;line-height: 34px;">
                  客户池
                </v-div>
              </v-toolbar>-->
              <div
                style="width:300px;height:34px;line-height:34px;overflow:hidden;background:#00cae3;color:#fff;"
              >
                <v-icon
                  small
                  style="color:#fff;margin-left:8px"
                >
                  mdi mdi-account-convert
                </v-icon>
                客户池   {{ dataList1.length ? dataList1.length : '' }}
              </div>
              <v-divider />
              <v-list
                class="y-scroll"
                style="height:72vh;overflow-y:scroll"
              >
                <div
                  v-for="(list, index) in dataList1"
                  :key="index"
                >
                  <v-alert
                    v-if="list.level === 1"
                    elevation="1"
                    border="left"
                    color="red"
                    colored-border
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                          @click="change_status(item, list.id)"
                        >
                          <v-list-item-title>{{ item.label }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                  <v-alert
                    v-else
                    elevation="1"
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                          @click="change_status(item, list.id)"
                        >
                          <v-list-item-title>{{ item.label }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                </div>
              </v-list>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            style="width:300px;max-width:300px;float:left;"
          >
            <v-list-item-content
              class="mx-auto"
              style="width:300px;"
            >
              <div
                style="width:300px;height:34px;line-height:34px;background:#FD9A13;color:#fff;"
              >
                <v-icon
                  small
                  style="color:#fff;margin-left:8px"
                >
                  mdi mdi-account-heart
                </v-icon>
                待定   {{ dataList2.length ? dataList2.length : '' }}
              </div>
              <v-divider />
              <v-list
                class="y-scroll"
                style="height:72vh;overflow-y:scroll"
              >
                <div
                  v-for="(list, index) in dataList10"
                  :key="index"
                >
                  <v-alert
                    elevation="1"
                    border="left"
                    color="red"
                    colored-border
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                          @click="change_status(item, list.id)"
                        >
                          <v-list-item-title>{{ item.label }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:25px;padding-bottom:10px;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                </div>
                <div
                  v-for="(list, index) in dataList2"
                  :key="index"
                >
                  <v-alert
                    elevation="1"
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                          @click="change_status(item, list.id)"
                        >
                          <v-list-item-title>{{ item.label }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:25px;padding-bottom:10px;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                </div>
              </v-list>
            </v-list-item-content>
          </v-list-item>

          <!--<v-list-item
            style="width:300px;max-width:300px;float:left;"
          >
            <v-list-item-content
              class="mx-auto"
              style="width:300px;"
            >
              <div
                style="width:300px;height:34px;line-height:34px;background:rgb(16 175 74 / 63%);color:#fff;"
              >
                <v-icon
                  small
                  style="color:#fff;margin-left:8px"
                >
                  mdi mdi-account-heart
                </v-icon>
                高价值待定    {{ dataList10.length ? dataList10.length : '' }}
              </div>
              <v-divider />
              <v-list
                class="y-scroll"
                style="height:72vh;overflow-y:scroll"
              >
                <div
                  v-for="(list, index) in dataList10"
                  :key="index"
                >
                  <v-alert
                    elevation="1"
                    border="left"
                    color="red"
                    colored-border
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                          @click="change_status(item, list.id)"
                        >
                          <v-list-item-title>{{ item.label }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:25px;padding-bottom:10px;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                </div>
              </v-list>
            </v-list-item-content>
          </v-list-item>-->

          <v-list-item
            style="width:300px;max-width:300px;float:left;"
          >
            <v-list-item-content
              class="mx-auto"
              style="width:300px;"
            >
              <div
                style="width:300px;height:34px;line-height:34px;overflow:hidden;background:#009688;color:#fff;"
              >
                <v-icon
                  small
                  style="color:#fff;margin-left:8px"
                >
                  mdi mdi-account-star
                </v-icon>
                有效约见    {{ dataList3.length ? dataList3.length : '' }}
              </div>
              <v-divider />

              <v-list
                class="y-scroll"
                style="height:72vh;overflow-y:scroll"
              >
                <div
                  v-for="(list, index) in dataList3"
                  :key="index"
                >
                  <v-alert
                    v-if="list.level === 1"
                    elevation="1"
                    border="left"
                    color="red"
                    colored-border
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                        >
                          <v-list-item-title
                            v-if="item.value === 37"
                            style="color:#eeeeee;"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                          <v-list-item-title
                            v-else
                            @click="change_status(item, list.id)"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                  <v-alert
                    v-else
                    elevation="1"
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                        >
                          <v-list-item-title
                            v-if="item.value === 37"
                            style="color:#eeeeee;"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                          <v-list-item-title
                            v-else
                            @click="change_status(item, list.id)"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                </div>
              </v-list>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            style="width:300px;max-width:300px;float:left;"
          >
            <v-list-item-content
              class="mx-auto"
              style="width:300px;"
            >
              <div
                style="width:300px;height:34px;line-height:34px;overflow:hidden;background:#2196f3;color:#fff;"
              >
                <v-icon
                  small
                  style="color:#fff;margin-left:8px"
                >
                  mdi mdi-account-plus
                </v-icon>
                报价后高意愿    {{ dataList4.length ? dataList4.length : '' }}
              </div>
              <v-divider />

              <v-list
                class="y-scroll"
                style="height:72vh;overflow-y:scroll"
              >
                <div
                  v-for="(list, index) in dataList4"
                  :key="index"
                >
                  <v-alert
                    v-if="list.level === 1"
                    elevation="1"
                    border="left"
                    color="red"
                    colored-border
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                        >
                          <v-list-item-title
                            v-if="item.value === 37"
                            style="color:#eeeeee;"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                          <v-list-item-title
                            v-else
                            @click="change_status(item, list.id)"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                  <v-alert
                    v-else
                    elevation="1"
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                        >
                          <v-list-item-title
                            v-if="item.value === 37"
                            style="color:#eeeeee;"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                          <v-list-item-title
                            v-else
                            @click="change_status(item, list.id)"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                </div>
              </v-list>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            style="width:300px;max-width:300px;float:left;"
          >
            <v-list-item-content
              class="mx-auto"
              style="width:300px;"
            >
              <div
                style="width:300px;height:34px;line-height:34px;overflow:hidden;background:#cddc39;color:#fff;"
              >
                <v-icon
                  small
                  style="color:#fff;margin-left:8px"
                >
                  mdi mdi-account-minus
                </v-icon>
                报价后低意愿    {{ dataList5.length ? dataList5.length : '' }}
              </div>
              <v-divider />

              <v-list
                class="y-scroll"
                style="height:72vh;overflow-y:scroll"
              >
                <div
                  v-for="(list, index) in dataList5"
                  :key="index"
                >
                  <v-alert
                    v-if="list.level === 1"
                    elevation="1"
                    border="left"
                    color="red"
                    colored-border
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                        >
                          <v-list-item-title
                            v-if="item.value === 37"
                            style="color:#eeeeee;"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                          <v-list-item-title
                            v-else
                            @click="change_status(item, list.id)"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                  <v-alert
                    v-else
                    elevation="1"
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                        >
                          <v-list-item-title
                            v-if="item.value === 37"
                            style="color:#eeeeee;"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                          <v-list-item-title
                            v-else
                            @click="change_status(item, list.id)"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                </div>
              </v-list>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            style="width:300px;max-width:300px;float:left;"
          >
            <v-list-item-content
              class="mx-auto"
              style="width:300px;"
            >
              <div
                style="width:300px;height:34px;line-height:34px;overflow:hidden;background:#4caf50;color:#fff;"
              >
                <v-icon
                  small
                  style="color:#fff;margin-left:8px"
                >
                  mdi-alert-decagram
                </v-icon>
                签约    {{ dataList6.length ? dataList6.length : '' }}
              </div>
              <v-divider />
              <v-list
                class="y-scroll"
                style="height:72vh;overflow-y:scroll"
              >
                <div
                  v-for="(list, index) in dataList6"
                  :key="index"
                >
                  <v-alert
                    v-if="list.level === 1"
                    elevation="1"
                    border="left"
                    color="red"
                    colored-border
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                        >
                          <v-list-item-title
                            v-if="item.value === 37"
                            style="color:#eeeeee;"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                          <v-list-item-title
                            v-else
                            @click="change_status(item, list.id)"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                  <v-alert
                    v-else
                    elevation="1"
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                        >
                          <v-list-item-title
                            v-if="item.value === 37"
                            style="color:#eeeeee;"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                          <v-list-item-title
                            v-else
                            @click="change_status(item, list.id)"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                </div>
              </v-list>
            </v-list-item-content>
          </v-list-item>

          <!--<v-list-item
            style="width:300px;max-width:300px;float:left;"
          >
            <v-list-item-content
              class="mx-auto"
              style="width:300px;"
            >
              <div
                style="width:300px;height:34px;line-height:34px;overflow:hidden;background:#795548;color:#fff;"
              >
                <v-icon
                  small
                  style="color:#fff;margin-left:8px"
                >
                  mdi-account-remove
                </v-icon>
                谎称要签    {{ dataList7.length ? dataList7.length : '' }}
              </div>
              <v-divider />
              <v-list
                class="y-scroll"
                style="height:72vh;overflow-y:scroll"
              >
                <div
                  v-for="(list, index) in dataList7"
                  :key="index"
                >
                  <v-alert
                    v-if="list.level === 1"
                    elevation="1"
                    border="left"
                    color="red"
                    colored-border
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                          @click="change_status(item, list.id)"
                        >
                          <v-list-item-title>{{ item.label }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                  <v-alert
                    v-else
                    elevation="1"
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                          @click="change_status(item, list.id)"
                        >
                          <v-list-item-title>{{ item.label }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                </div>
              </v-list>
            </v-list-item-content>
          </v-list-item>-->

          <v-list-item
            style="width:300px;max-width:300px;float:left;"
          >
            <v-list-item-content
              class="mx-auto"
              style="width:300px;"
            >
              <div
                style="width:300px;height:34px;line-height:34px;overflow:hidden;background:#607d8b;color:#fff;"
              >
                <v-icon
                  small
                  style="color:#fff;margin-left:8px"
                >
                  mdi-account-switch
                </v-icon>
                输单   {{ dataList8.length ? dataList8.length : '' }}
              </div>
              <v-divider />
              <v-list
                class="y-scroll"
                style="height:72vh;overflow-y:scroll"
              >
                <div
                  v-for="(list, index) in dataList8"
                  :key="index"
                >
                  <v-alert
                    v-if="list.level === 1"
                    elevation="1"
                    border="left"
                    color="red"
                    colored-border
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                        >
                          <v-list-item-title
                            v-if="item.value === 37"
                            style="color:#eeeeee;"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                          <v-list-item-title
                            v-else
                            @click="change_status(item, list.id)"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                  <v-alert
                    v-else
                    elevation="1"
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                        >
                          <v-list-item-title
                            v-if="item.value === 37"
                            style="color:#eeeeee;"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                          <v-list-item-title
                            v-else
                            @click="change_status(item, list.id)"
                          >
                            {{ item.label }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                </div>
              </v-list>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            style="width:300px;max-width:300px;float:left;"
          >
            <v-list-item-content
              class="mx-auto"
              style="width:300px;"
            >
              <div
                style="width:300px;height:34px;line-height:34px;overflow:hidden;background:#9e9e9e;color:#fff;"
              >
                <v-icon
                  small
                  style="color:#fff;margin-left:8px"
                >
                  mdi-account-switch
                </v-icon>
                无效   {{ dataList9.length ? dataList9.length : '' }}
              </div>
              <v-divider />
              <v-list
                class="y-scroll"
                style="height:72vh;overflow-y:scroll"
              >
                <div
                  v-for="(list, index) in dataList9"
                  :key="index"
                >
                  <v-alert
                    v-if="list.level === 1"
                    elevation="1"
                    border="left"
                    color="red"
                    colored-border
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                          @click="change_status(item, list.id)"
                        >
                          <v-list-item-title>{{ item.label }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                  <v-alert
                    v-else
                    elevation="1"
                    style="width: 264px;margin-top:4px;margin-left:1px;"
                  >
                    <v-menu
                      bottom
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="mr-2"
                          style="font-size:24px;"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-arrange-send-backward
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, i) in items"
                          :key="i"
                          @click="change_status(item, list.id)"
                        >
                          <v-list-item-title>{{ item.label }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      class="font-weight-medium"
                      style="width:100%;display:inline; line-height:22px;cursor: pointer;"
                      @click="change_item(list)"
                    >
                      <span v-if="list.company">{{ list.company }}</span>
                      <span v-else>{{ list.description }}</span>
                      <v-btn
                        v-if="list.date_status === 1"
                        small
                        color="error"
                      >
                        {{ list.date_str }}
                      </v-btn>
                      <v-btn
                        v-if="list.date_status === 0"
                        small
                        color="primary"
                      >
                        {{ list.date_str }}
                      </v-btn>
                    </div>
                  </v-alert>
                </div>
              </v-list>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <div
          v-if="sortDesc===true"
          style="margin-top:60px;"
        >
          <v-data-table
            :headers="headers"
            :items="desserts"
            sort-by="calories"
            class="elevation-1"
            style="color:black"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:item.status="{ item }">
              <v-chip
                :color="getColor(item.status)"
                dark
              >
                {{ item.status }}
              </v-chip>
            </template>
            <template v-slot:item.is_sale="{ item }">
              <span
                v-if="item.is_sale===1"
                style="color:#2196f3"
              >
                自拓
              </span>
              <span v-else>分配</span>
            </template>
            <template v-slot:item.company="{ item }">
              {{ item.company ? item.company : item.description }}
              <v-btn
                v-if="item.date_status === 1"
                small
                color="error"
              >
                {{ item.date_str }}
              </v-btn>
              <v-btn
                v-if="item.date_status === 0"
                small
                color="primary"
              >
                {{ item.date_str }}
              </v-btn>
            </template>
            <template v-slot:item.level="{ item }">
              <span
                v-if="item.level"
                style="color:blue; font-weight:800"
              >
                是
              </span>
              <span v-else>否</span>
            </template>
            <template
              v-slot:item.actions="{ item }"
            >
              <v-icon
                small
                class="mr-2"
                @click="change_item(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                v-if="item.is_sale===1"
                small
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn
                color="primary"
                @click="initialize"
              >
                Reset
              </v-btn>
            </template>
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
            />
          </div>
        </div>
      </v-tab-item>
      <!--tab2-content-->
      <v-tab-item
        key="2"
        value="tab-2"
        class="pa-5"
      >
        <v-card flat>
          <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <h3>
                基本信息
              </h3><br>
              <v-text-field
                :value="userInfo.username"
                label="用户名"
                disabled
              />

              <v-text-field
                :value="userInfo.name"
                label="姓名"
                disabled
              />

              <v-text-field
                :value="userInfo.phone"
                label="手机号"
                disabled
              />
              <v-card-title>修改密码</v-card-title>
              <v-text-field
                v-model="old_pass"
                :counter="20"
                :rules="oldpassRules"
                label="原密码"
                required
                @blur="checkUser"
              />

              <v-text-field
                v-model="password"
                :counter="20"
                :rules="passwordRules"
                label="新密码"
                type="password"
                required
              />

              <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4"
                @click="validate"
              >
                提交
              </v-btn>

              <v-btn
                color="error"
                class="mr-4"
                @click="reset"
              >
                重置
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <!--项目详情-->
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
            dark
            color="primary"
          >
            <v-btn
              icon
              dark
              @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>客户详情</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                dark
                @click="save"
              >
                Save
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list
            three-line
            subheader
          >
            <v-subheader>客户信息</v-subheader>
            <v-row
              class="spacing-playground pa-3"
            >
              <v-col
                cols="24"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.no"
                  label="客户编号"
                  disabled
                />
              </v-col>
              <v-col
                cols="24"
                md="4"
              >
                <v-select
                  v-model="editedItem.industry"
                  :items="industryArr"
                  :menu-props="{ top: true, offsetY: true }"
                  item-text="name"
                  item-value="id"
                  label="行业"
                  required
                />
              </v-col>
              <v-col
                cols="24"
                md="4"
              >
                <v-select
                  v-model="editedItem.region"
                  :items="regionArr"
                  :menu-props="{ top: true, offsetY: true }"
                  item-text="name"
                  item-value="name"
                  label="地域"
                  required
                />
                <!--<v-text-field
                  v-model="editedItem.region"
                  label="地域"
                />-->
              </v-col>
              <v-col
                cols="24"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.company"
                  label="公司名称/客户简称(必填)"
                />
              </v-col>
              <v-col
                cols="24"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.name"
                  label="联系人"
                />
              </v-col>
              <v-col
                cols="24"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.phone"
                  label="联系电话"
                />
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-textarea
                  v-model="editedItem.description"
                  label="项目概况"
                  rows="3"
                />
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-radio-group
                  v-model="editedItem.status"
                  mandatory
                  row
                  label="结果"
                >
                  <div
                    v-for="(item, i) in items"
                    :key="i"
                  >
                    <v-radio
                      v-if="(editedItem.status === 31 || editedItem.status === 32 || editedItem.status === 33 || editedItem.status === 34 || editedItem.status === 36 || editedItem.status === 35) && item.value === 37"
                      :key="i"
                      disabled
                      :label="item.label"
                      :value="item.value"
                    />
                    <v-radio
                      v-else
                      :key="i"
                      :label="item.label"
                      :value="item.value"
                    />
                  </div>
                </v-radio-group>
              </v-col>
              <v-col
                v-if="editedItem.status === 37"
                cols="24"
                md="6"
              >
                <v-select
                  v-model="editedItem.invalid_status"
                  :items="invalid_Arr"
                  :menu-props="{ top: true, offsetY: true }"
                  item-text="name"
                  item-value="id"
                  label="无效原因(必填)"
                  required
                />
              </v-col>
              <v-col
                v-if="editedItem.status === 37"
                cols="24"
                md="6"
              >
                <v-text-field
                  v-model="editedItem.invalid_tip"
                  label="无效原因注释(必填)"
                  required
                />
              </v-col>
              <v-col
                v-if="editedItem.status === 35"
                cols="24"
                md="6"
              >
                <v-select
                  v-model="editedItem.sole_status"
                  :items="sole_Arr"
                  :menu-props="{ top: true, offsetY: true }"
                  item-text="name"
                  item-value="id"
                  label="输单原因(必填)"
                  required
                />
              </v-col>
              <v-col
                v-if="editedItem.status === 35"
                cols="24"
                md="6"
              >
                <v-text-field
                  v-model="editedItem.sole_tip"
                  label="输单原因注释(必填)"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-select
                  v-model="editedItem.user_id"
                  :items="keys"
                  :menu-props="{ top: true, offsetY: true }"
                  item-text="name"
                  item-value="id"
                  label="商务负责人"
                  required
                />
              </v-col>
              <!--<v-col
                cols="12"
                md="4"
              >
                <v-menu
                  ref="menu_2"
                  v-model="menu_2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.start_at"
                      label="设置开始时间"
                      persistent-hint
                      clearable
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="editedItem.start_at"
                    no-title
                    @input="menu_2 = false"
                  />
                </v-menu>
              </v-col>-->
              <v-col
                cols="12"
                md="4"
              >
                <v-menu
                  ref="menu_1"
                  v-model="menu_1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.end_at"
                      label="设置截止时间"
                      persistent-hint
                      clearable
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="editedItem.end_at"
                    locale="zh-cn"
                    no-title
                    @input="menu_1 = false"
                  />
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-slider
                  v-model="editedItem.weight"
                  color="blue"
                  label="权重"
                  hint="权重值越大排序越靠前"
                  min="0"
                  max="100"
                  thumb-label
                />
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-textarea
                  v-model="editedItem.log"
                  label="生命周期日志"
                  hint="从分配任务到签单过程中的事件记录到生命周期中，换行分割"
                  rows="2"
                  @blur="savelog()"
                />
                <span style="color:#616161;">填写日志后，鼠标在任意空白位置点击即可保存日志</span>
              </v-col>
              <v-col
                cols="24"
                md="12"
              >
                <v-alert
                  border="right"
                  color="blue-grey"
                  dark
                >
                  以下内容为该客户生命周期日志
                </v-alert>
                <v-timeline
                  :reverse="reverse"
                  dense
                >
                  <v-timeline-item
                    v-for="(life, i) in life_cycle"
                    :key="i"
                    small
                  >
                    <v-card class="elevation-2">
                      <v-card-title class="headline">
                        {{ life.author }} - {{ life.created_at }}
                      </v-card-title>
                      <v-card-text
                        style="color:#000"
                      >
                        {{ life.description }}
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-col>
            </v-row>
          </v-list>
        </v-card>
      </v-dialog>
    </v-row>
    <!--添加start-->
    <v-dialog
      v-model="dialogAdd"
      max-width="0px"
    >
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
      >
        <form @submit.prevent="submit">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row justify="center">
                  <v-dialog
                    v-model="dialogAdd"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                  >
                    <v-card>
                      <v-toolbar
                        dark
                        color="primary"
                      >
                        <v-btn
                          icon
                          dark
                          @click="dialogAdd = false"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                        <v-spacer />
                        <v-toolbar-items>
                          <v-btn
                            dark
                            color="success"
                            type="submit"
                            :disabled="invalid"
                            @click="sava_add"
                          >
                            保存
                          </v-btn>
                        </v-toolbar-items>
                      </v-toolbar>
                      <v-divider />
                      <v-card
                        class="mb-12"
                        color="red lighten-5"
                      >
                        <v-row
                          class="light-blue lighten-5 pa-6"
                        >
                          <!--<v-col
                            cols="24"
                            md="6"
                          >
                            <v-menu
                              v-model="menu2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="访问日期"
                                  rules="required"
                                >
                                  <v-text-field
                                    v-model="addItem.extension_date"
                                    label="访问日期"
                                    :error-messages="errors"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  />
                                </validation-provider>
                              </template>
                              <v-date-picker
                                v-model="addItem.extension_date"
                                locale="zh-cn"
                                @input="menu2 = false"
                              />
                            </v-menu>
                          </v-col>
                          <v-col>
                            <v-text-field
                              v-model="addItem.extension_tm"
                              label="时间"
                              prepend-icon="mdi-clock-time-four-outline"
                            />
                          </v-col>-->
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <validation-provider
                              v-slot="{ errors }"
                              name="商务负责人"
                              rules="required"
                            >
                              <v-select
                                v-model="addItem.user_id"
                                :items="keys"
                                :menu-props="{ top: true, offsetY: true }"
                                :error-messages="errors"
                                item-text="name"
                                item-value="id"
                                label="商务负责人"
                                required
                              />
                            </validation-provider>
                          </v-col>
                          <v-col
                            cols="24"
                            md="12"
                          >
                            <validation-provider
                              v-slot="{ errors }"
                              name="概况描述"
                              rules="required"
                            >
                              <v-textarea
                                v-model="addItem.description"
                                :error-messages="errors"
                                label="概况描述"
                                rows="7"
                              />
                            </validation-provider>
                          </v-col>
                          <v-col
                            cols="24"
                            md="12"
                          >
                            <v-alert
                              outlined
                            >
                              填写信息后，点击右上角的【保存】提交
                            </v-alert>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-card>
                  </v-dialog>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </form>
      </validation-observer>
    </v-dialog>
    <!--添加end-->
    <v-dialog
      v-model="dialogDelete"
      max-width="300px"
    >
      <v-card>
        <v-card-title
          class="headline"
        >
          请确认是否删除?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDelete"
          >
            取消
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="deleteItemConfirm"
          >
            确定
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import axios from 'axios'
  import { required } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
  extend('required', {
    ...required,
    message: '{_field_} 不能为空',
  })
  export default {
    name: 'UserProfileView',
    components: {
      ValidationObserver,
      ValidationProvider,
    },
    data () {
      return {
        menu2: false,
        reverse: true,
        dialog: false,
        status: '',
        uid: '',
        tab: null,
        settings: [],
        valid: true,
        old_pass: '',
        userInfo: [],
        oldpassRules: [
          v => !!v || '原密码不能为空',
        ],
        password: '',
        passwordRules: [
          v => !!v || '请输入新的密码并牢记',
          v => v.length >= 6 || '密码必须为大于等于６个字符',
          // v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        repassword: '',
        repasswordRules: [
          v => !!v || '确认密码不能为空',
          // v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        items: [
          {
            value: 29,
            label: '客户池',
          },
          {
            value: 30,
            label: '待定',
          },
          {
            value: 51,
            label: '高价值待定',
          },
          {
            value: 31,
            label: '有效约见',
          },
          {
            value: 32,
            label: '报价后高意愿',
          },
          {
            value: 33,
            label: '报价后低意愿',
          },
          {
            value: 36,
            label: '签约',
          },
          /* {
            value: 34,
            label: '谎称要签',
          }, */
          {
            value: 35,
            label: '输单',
          },
          {
            value: 37,
            label: '无效',
          },
        ],
        dataList1: [],
        dataList2: [],
        dataList3: [],
        dataList4: [],
        dataList5: [],
        dataList6: [],
        dataList7: [],
        dataList8: [],
        dataList9: [],
        dataList10: [],
        life_cycle: [],
        industryArr: [],
        regionArr: [],
        invalid_Arr: [],
        sole_Arr: [],
        editedItem: {
          no: '',
          name: '',
          company: '',
          phone: '',
          region: '',
          industry: '',
          customer_status: '',
          invalid_status: '',
          invalid_tip: '',
          sole_status: '',
          sole_tip: '',
          description: '',
          status: 29,
          life_cycle: '',
          start_at: '',
          end_at: '',
          weight: 1,
        },
        keyword: '',
        filter: {},
        sortDesc: false,
        keys: [],
        dates: [],
        menu1: false,
        dateFormatted: '',
        menu_1: false,
        menu_2: false,
        headers: [
          {
            text: '客户编号',
            align: 'center',
            value: 'no',
            width: '150',
          },
          { text: '时间', value: 'extension_date', width: '100' },
          { text: '分配AE', value: 'auther', width: '100' },
          { text: '公司名称/概况', value: 'company', sortable: false, width: '260' },
          { text: '客户来源', value: 'customer_source_name', width: '120' },
          { text: '地域', value: 'region', width: '120' },
          // { text: '线索来源', value: 'source_name', width: '120' },
          // { text: '联系人', value: 'name', sortable: false, width: '100' },
          // { text: '电话', value: 'phone', sortable: false, width: '120' },
          // { text: '其他联系方式', value: 'other_phone', width: '160' },
          // { text: '公司名称', value: 'company', sortable: false, width: '150' },
          // { text: '搜索词', value: 'search_keyword', width: '120' },
          // { text: '关键词', value: 'keyword', width: '120' },
          { text: '高价值', value: 'level', width: '120' },
          { text: '结果', value: 'status', width: '100' },
          { text: '无效原因', value: 'invalid_name', width: '200' },
          { text: '客户类型', value: 'is_sale', width: '120' },
          // { text: '初步判断', value: 'type', width: '120' },
          // { text: '无效原因', value: 'remarks', sortable: false, width: '150' },
          { text: '操作', value: 'actions', sortable: false, width: '100' },
        ],
        desserts: [],
        page: 1,
        pageCount: 0,
        itemsPerPage: 12,
        classifyArr: [],
        dialogDelete: false,
        dialogAdd: false,
        defaultItem: {
          description: '',
          status: 29,
          remarks: '',
          auther: '',
        },
        addItem: {
          extension_date: new Date().toISOString().substr(0, 10),
          extension_time: '9:00-12:00',
          extension_tm: new Date().toLocaleTimeString('chinese', { hour12: false }).substr(0, 8),
          description: '',
          is_sale: 1,
          auther: '',
        },
        defaultAddItem: {
          extension_date: new Date().toISOString().substr(0, 10),
          extension_time: '9:00-12:00',
          extension_tm: new Date().toLocaleTimeString('chinese', { hour12: false }).substr(0, 8),
          description: '',
          is_sale: 1,
          auther: '',
        },
      }
    },

    computed: {
      formTitle () {
        return '录入客户信息'
      },
    },

    watch: {
      dialogAdd (val) {
        val || this.closeAdd()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        // 获取销售列表
        axios
          .get(process.env.VUE_APP_BASE_API + '/customer/admins')
          .then(response => {
            if (response.status === 200) {
              this.keys = response.data.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        // 获取lib
        axios
          .get(process.env.VUE_APP_BASE_API + '/classify/all')
          .then(response => {
            if (response.data.code === 20000) {
              this.classifyArr = response.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        // 获取用户列表
        axios
          .get(process.env.VUE_APP_BASE_API + '/admins/profile')
          .then(response => {
            if (response.data.code === 20000) {
              this.userInfo = response.data.data
              this.editedItem.user_id = this.addItem.user_id = this.uid = response.data.data.id
            }
          })
          .catch(error => {
            console.log(error)
          })
        // 获取工作
        this.mywork()
      },
      mywork () {
        axios
          .post(process.env.VUE_APP_BASE_API + '/customer/mywork', { userId: this.uid, keyword: this.keyword, dates: this.dates, status: this.status })
          .then(response => {
            if (response.data.code === 20000) {
              this.dataList1 = response.data.data.dataList1
              this.dataList2 = response.data.data.dataList2
              this.dataList3 = response.data.data.dataList3
              this.dataList4 = response.data.data.dataList4
              this.dataList5 = response.data.data.dataList5
              this.dataList6 = response.data.data.dataList6
              this.dataList7 = response.data.data.dataList7
              this.dataList8 = response.data.data.dataList8
              this.dataList9 = response.data.data.dataList9
              this.dataList10 = response.data.data.dataList10

              this.desserts = response.data.data.data.data
              this.desserts.map((item, i, arr) => {
                switch (item.status) {
                  case 29:
                    item.status = '客户池'
                    break
                  case 30:
                    item.status = '待定'
                    break
                  case 51:
                    item.status = '高价值待定'
                    break
                  case 31:
                    item.status = '有效约见'
                    break
                  case 32:
                    item.status = '报价后高意愿'
                    break
                  case 33:
                    item.status = '报价后低意愿'
                    break
                  case 36:
                    item.status = '签约'
                    break
                  /* case 34:
                    item.status = '谎称要签'
                    break */
                  case 35:
                    item.status = '输单'
                    break
                  case 37:
                    item.status = '无效'
                    break
                }
                item.customer_source_name = this.classifyArr[item.customer_source]
                item.source_name = this.classifyArr[item.source]
                const invalid = item.invalid_tip !== null ? '(' + item.invalid_tip + ')' : ''
                const sole = item.sole_tip !== null ? '(' + item.sole_tip + ')' : ''
                const iname = this.classifyArr[item.invalid_status] + invalid
                item.invalid_name = iname !== 'undefined' ? iname : ''
                const isole = this.classifyArr[item.sole_status] + sole
                item.sole_name = isole !== 'undefined' ? isole : ''
              })
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      validate () {
        const _this = this
        this.$refs.form.validate()
        if (this.password !== '' && this.old_pass !== '') {
          axios
            .post(process.env.VUE_APP_BASE_API + '/admins/password', { pass: this.password })
            .then(response => {
              if (response.data.code === 20000) {
                this.$message.success(response.data.msg)
                this.old_pass = ''
                _this.$router.push('/')
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      },
      reset () {
        // this.$refs.form.reset()
        this.old_pass = ''
        this.password = ''
        this.$refs.form.resetValidation()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      change_status (item, id) {
        axios
          .post(process.env.VUE_APP_BASE_API + '/customer/status/' + id, { label: item.label, status: item.value })
          .then(response => {
            if (response.data.code === 20000) {
              this.initialize()
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      change_item (list) {
        this.editedItem = Object.assign({}, list)
        switch (list.status) {
          case '客户池':
            this.editedItem.status = 29
            break
          case '待定':
            this.editedItem.status = 30
            break
          case '高价值待定':
            this.editedItem.status = 51
            break
          case '有效约见':
            this.editedItem.status = 31
            break
          case '报价后高意愿':
            this.editedItem.status = 32
            break
          case '报价后低意愿':
            this.editedItem.status = 33
            break
          case '签约':
            this.editedItem.status = 36
            break
          /* case '谎称要签':
            this.editedItem.status = 34
            break */
          case '输单':
            this.editedItem.status = 35
            break
          case '无效':
            this.editedItem.status = 37
            break
        }
        axios
          .post(process.env.VUE_APP_BASE_API + '/classify/get_sub/1')
          .then(response => {
            if (response.data.code === 20000) {
              this.industryArr = response.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        axios
          .post(process.env.VUE_APP_BASE_API + '/classify/get_sub/52')
          .then(response => {
            if (response.data.code === 20000) {
              this.regionArr = response.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        axios
          .post(process.env.VUE_APP_BASE_API + '/classify/get_sub/6')
          .then(response => {
            if (response.data.code === 20000) {
              this.invalid_Arr = response.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        axios
          .post(process.env.VUE_APP_BASE_API + '/classify/get_sub/43')
          .then(response => {
            if (response.data.code === 20000) {
              this.sole_Arr = response.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
        this.lifecycle(list.id)
        this.dialog = true
      },
      lifecycle (id) {
        axios
          .post(process.env.VUE_APP_BASE_API + '/customer/life_cycle/' + id)
          .then(response => {
            if (response.data.code === 20000) {
              this.life_cycle = response.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      save () {
        const item = this.editedItem
        const url = process.env.VUE_APP_BASE_API + '/customer/update/' + item.id
        if (item.company === '' || item.company === null) {
          this.$message.error('需填写公司名称/客户简称!')
          return false
        }
        if (item.status === 37 && (item.invalid_status === '' || item.invalid_tip === '' || item.invalid_status === null || item.invalid_tip === null)) {
          this.$message.error('需填写无效原因及注释!')
          return false
        }
        if (item.status === 35 && (item.sole_status === undefined || item.sole_tip === undefined || item.sole_status === null || item.sole_tip === null || item.sole_status === '' || item.sole_tip === '')) {
          this.$message.error('需填写输单原因及注释!')
          return false
        }
        axios
          .post(url, this.editedItem)
          .then(response => {
            if (response.data.code === 20000) {
              this.$message.success('提交成功')
              this.initialize()
            }
          })
          .catch(error => {
            console.log(error)
          })
        this.dialog = false
      },
      checkUser () {
        if (this.old_pass !== '') {
          axios
            .post(process.env.VUE_APP_BASE_API + '/admins/check_user', { oldpass: this.old_pass, validate: 'oldpass' })
            .then(response => {
              if (response.data.data === 'yes') {
                this.$message.error(response.data.msg)
                this.old_pass = ''
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      },
      selectsw () {
        this.mywork()
      },
      savelog () {
        const editObj = this.editedItem
        if (editObj.log !== undefined && editObj.log.trim() !== '') {
          const url = process.env.VUE_APP_BASE_API + '/customer/savelog/' + editObj.id
          axios
            .post(url, { log: editObj.log })
            .then(response => {
              if (response.data.code === 20000) {
                this.$message.success('保存成功')
                this.lifecycle(editObj.id)
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      },
      getColor (calories) {
        let color = 'green'
        switch (calories) {
          case '客户池':
            color = 'info'
            break
          case '待定':
            color = '#FD9A13'
            break
          case '高价值待定':
            color = 'rgb(16 175 74 / 63%)'
            break
          case '有效约见':
            color = 'teal'
            break
          case '报价后高意愿':
            color = 'blue'
            break
          case '报价后低意愿':
            color = 'lime'
            break
          case '签约':
            color = 'green'
            break
          /* case '谎称要签':
            color = 'brown'
            break */
          case '输单':
            color = 'blue-grey'
            break
          case '无效':
            color = 'grey'
            break
        }
        return color
      },
      sava_add () {
        this.$refs.observer.validate()
        if (this.addItem.description !== '' && this.addItem.user_id !== '') {
          const item = this.addItem
          const url = process.env.VUE_APP_BASE_API + '/customer/create'
          this.addItem.roles = this.roles
          axios
            .post(url, this.addItem)
            .then(response => {
              if (response.data.code === 20000) {
                switch (item.status) {
                  case 29:
                    item.status = '客户池'
                    break
                  case 30:
                    item.status = '待定'
                    break
                  case 51:
                    item.status = '高价值待定'
                    break
                  case 31:
                    item.status = '有效约见'
                    break
                  case 32:
                    item.status = '报价后高意愿'
                    break
                  case 33:
                    item.status = '报价后低意愿'
                    break
                  case 36:
                    item.status = '签约'
                    break
                  /* case 34:
                    item.status = '谎称要签'
                    break */
                  case 35:
                    item.status = '输单'
                    break
                  case 37:
                    item.status = '无效'
                    break
                }
                item.id = response.data.id
                item.auther = response.data.auther
                item.no = response.data.no
                // this.desserts.push(item)
                this.initialize()
              }
            })
            .catch(error => {
              console.log(error)
            })
          this.closeAdd()
        }
      },
      add () {
        this.dialogAdd = true
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeAdd () {
        this.dialogAdd = false
        this.$nextTick(() => {
          this.addItem = Object.assign({}, this.defaultAddItem)
        })
      },
      deleteItem (item) {
        this.editedItem = Object.assign({}, item)
        // console.log(this.editedItem)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        axios
          .delete(process.env.VUE_APP_BASE_API + '/customer/destroy/' + this.editedItem.id)
          .then(response => {
            if (response.data.code === 20000) {
              // this.desserts.splice(this.editedIndex, 1)
              this.initialize()
            }
          })
          .catch(error => {
            console.log(error)
          })
        this.closeDelete()
      },
    },
  }
</script>

<style scoped>
.v-card {
  max-width: 3000px;
}
.v-toolbar__content{
  height: 30px;
}
.y-scroll::-webkit-scrollbar-track{
  -webkit-box-shadow:inset005pxrgba(0,0,0,0.2);
  border-radius:0;
}
.y-scroll::-webkit-scrollbar{
  width:2px;
  height:2px;
}
.y-scroll::-webkit-scrollbar-thumb{
  border-radius:2px;
  -webkit-box-shadow:inset005pxrgba(0,0,0,0.2);
  background:rgba(60, 117, 241, 0.2);
}
</style>
